import { create } from "zustand";

interface State {
    /** Sidebar visible en móvil (overlay deslizante). En desktop siempre visible. */
    isSideMenuOpen: boolean;
    openSideMenu: () => void;
    closeSideMenu: () => void;

    /** Sidebar contraído a riel de iconos (solo desktop). Se persiste. */
    isSideMenuCollapsed: boolean;
    toggleSideMenuCollapsed: () => void;
    setSideMenuCollapsed: (value: boolean) => void;
}

const COLLAPSE_KEY = "sidebar-collapsed";

function getInitialCollapsed(): boolean {
    if (typeof window === "undefined") return false;
    try {
        return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
        return false;
    }
}

function persistCollapsed(value: boolean) {
    if (typeof window === "undefined") return;
    try {
        localStorage.setItem(COLLAPSE_KEY, value ? "1" : "0");
    } catch {
        /* almacenamiento no disponible */
    }
}

export const useUIStore = create<State>()((set, get) => ({
    isSideMenuOpen: false,
    openSideMenu: () => set({ isSideMenuOpen: true }),
    closeSideMenu: () => set({ isSideMenuOpen: false }),

    isSideMenuCollapsed: getInitialCollapsed(),
    toggleSideMenuCollapsed: () => {
        const next = !get().isSideMenuCollapsed;
        persistCollapsed(next);
        set({ isSideMenuCollapsed: next });
    },
    setSideMenuCollapsed: (value: boolean) => {
        persistCollapsed(value);
        set({ isSideMenuCollapsed: value });
    },
}));
